import { api } from "./apiClient";

export const googleWorkspaceApi = {
  connection: () => api.get("/api/google-workspace"),
  connections: () => api.get("/api/google-workspace/connections"),
  connect: () => api.post("/api/google-workspace/connect", {}),
  disconnect: () => api.delete("/api/google-workspace"),
  disconnectConnection: (id) => api.delete(`/api/google-workspace/connections/${id}`),
  checkConnection: (id) => api.post(`/api/google-workspace/connections/${id}/check`, {}),
  triggers: {
    list: () => api.get("/api/google-drive-triggers"),
    create: (data) => api.post("/api/google-drive-triggers", data),
    update: (id, data) => api.put(`/api/google-drive-triggers/${id}`, data),
    remove: (id) => api.delete(`/api/google-drive-triggers/${id}`),
    run: (id) => api.post(`/api/google-drive-triggers/${id}/run`, {}),
  },
};
